import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useForm } from '../context/FormContext';
import { createSetStepAction } from '../types/form/actions';
export var StepIndicators = function (_a) {
    var steps = _a.steps, currentStep = _a.currentStep, _b = _a.disablePreviousSteps, disablePreviousSteps = _b === void 0 ? false : _b;
    var dispatch = useForm().dispatch;
    var _c = useState(currentStep), maxStepReached = _c[0], setMaxStepReached = _c[1];
    // Update maxStepReached when currentStep increases
    useEffect(function () {
        if (currentStep > maxStepReached) {
            setMaxStepReached(currentStep);
        }
    }, [currentStep, maxStepReached]);
    var handleStepClick = function (stepIndex) {
        // Only allow clicking if not disabled
        if ((!disablePreviousSteps && stepIndex + 1 <= maxStepReached) ||
            (disablePreviousSteps && stepIndex + 1 === currentStep)) {
            dispatch(createSetStepAction(stepIndex + 1));
        }
    };
    return (_jsx("div", { className: "tiof-step-indicators", children: steps.map(function (step, index) {
            var isActive = currentStep === index + 1;
            var isCompleted = currentStep > index + 1;
            var isFuture = index + 1 > maxStepReached;
            var isDisabled = (disablePreviousSteps && index + 1 !== currentStep) ||
                isFuture;
            return (_jsxs("div", { className: "tiof-step-indicator ".concat(isActive ? 'active' : '', " ").concat(isCompleted ? 'completed' : '', " ").concat(isFuture ? 'future' : '', " ").concat(isDisabled ? 'disabled' : ''), "data-step": index + 1, onClick: function () { return handleStepClick(index); }, style: { cursor: isDisabled ? 'not-allowed' : 'pointer' }, children: [_jsxs("span", { className: "tiof-step-number", children: ["Step ", index + 1] }), _jsx("span", { className: "tiof-step-label", children: step.label })] }, step.id));
        }) }));
};
